import { Icon } from "@iconify/react";

function FormInput({
  label,
  id,
  name,
  value,
  onChange,
  onBlur,
  error,
  isRequired = true,
  placeholder = "",
  containerStyle = "",
  labelStyle = "",
  inputStyle = "",
  disabled = false,
  type = "text",
  tooltip
}) {
  return (
    <div className={`mb-6 w-full ${containerStyle}`}>
      {label && (
        <>
          <label
            htmlFor={id}
            className={`form-label block font-inter text-secondary text-level-3 font-medium leading-[24px] ${labelStyle}`}
          >
            {label} {isRequired && <span className="text-light-red">*</span>}
          </label>
         {tooltip &&
          <div className="relative group cursor-pointer">
              <Icon
                icon="mdi:help-circle-outline"
                className="text-[#6B7280]"
                width={18}
                height={18}
              />
              <div className="absolute z-20 hidden group-hover:block bg-black text-white text-sm 
              rounded-md px-2 py-1 top-full mt-1 left-1/2 -translate-x-1/2 
              min-w-[300px] break-words text-center whitespace-normal">
                {tooltip}
              </div>
          </div>}
        </>
      )}
      <input
        id={id}
        name={name}
        value={value}
        onChange={(e) => onChange(name, e.target.value)}
        onBlur={(e) => onBlur(name, e.target.value)}
        placeholder={placeholder}
        type={type}
        disabled={disabled}
        className={`mt-[12px] px-[12px] w-full font-inter py-[15px] h-[48px] block rounded-[5px] text-gray text-[15px]
             border-[1.5px] border-medium-gray focus:border-blue-shades focus:outline-none hover:shadow-[1px_2px_8px_1px_#0020BD1F]
             ${inputStyle} ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
      />
      {error && (
        <p className="mt-1 pl-0 text-xs font-medium text-red-400">
          {error}
        </p>
      )}
    </div>
  );
}

export default FormInput;